import React, { Component } from 'react';
import {
  Image,
  ImageBackground,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  Button,
  View,
} from 'react-native';

import FirebaseUsers from '../firebase/firebase_users.js'
import Messaging from '../messaging.js';

import EonnTitle from '../components/title';
import EonnButton from '../components/button';
import EonnLink from '../components/link';
import EonnField from '../components/field';
import PhoneField from '../components/phone_field';
import { mstyles } from '../constants/MainStyles';

const styles = StyleSheet.create({
  sectionTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    marginTop: 30,
    marginBottom: 15,
    textAlign: 'center',
    color: '#333',
  },
  successMessage: {
    color: '#606060',
    fontSize: 16,
    textAlign: 'center',
    marginTop: -25,
    marginBottom: 45,
    fontStyle: 'italic',
  },
  errorMessage: {
    color: '#f44336',
    fontSize: 16,
    textAlign: 'center',
    marginTop: -25,
    marginBottom: 45,
    fontStyle: 'italic',
  },
});

export default class Screen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showRequired: false,
      err: "",
      emailError: false,
      pwError: false,
      password1: "",
      password2: "",
      password3: "",
      
      // Phone number fields
      phone: global.user.phone || "",
      countryCode: global.user.countryCode || "+1",
      
      // Success/Error messages
      phoneMessage: "",
      phoneMessageType: "", // 'success' or 'error'
      passwordMessage: "",
      passwordMessageType: "", // 'success' or 'error'
      
      // Password change section visibility
      showPasswordSection: false,
    };
    console.log(global.user);
    
    // Extract country code from phone if it exists
    const countryCodes = [
      { code: "+1", country: "US/Canada" },
      { code: "+44", country: "UK" },
      { code: "+61", country: "Australia" },
      { code: "+91", country: "India" },
      { code: "+33", country: "France" },
      { code: "+34", country: "Spain" },
      { code: "+49", country: "Germany" },
      { code: "+52", country: "Mexico" },
      { code: "+55", country: "Brazil" },
      { code: "+81", country: "Japan" },
      { code: "+82", country: "South Korea" },
      { code: "+86", country: "China" },
      { code: "+234", country: "Nigeria" },
    ];
    
    if (this.state.phone && this.state.phone.startsWith('+')) {
      const matchedCountry = countryCodes.find(item => 
        this.state.phone.startsWith(item.code));
      
      if (matchedCountry) {
        this.state.countryCode = matchedCountry.code;
        this.state.phone = this.state.phone.substring(matchedCountry.code.length);
      }
    }
  }

  updatePhone = async () => {
    this.setState({ 
      loading: true, 
      err: "", 
      phoneMessage: "", 
      phoneMessageType: "" 
    });

    try {
      // Validate phone number
      const cleanPhone = this.state.phone.replace(/[\s()-\.]/g, '');
      if (!/^[0-9]{6,12}$/.test(cleanPhone)) {
        this.setState({ 
          err: "Please enter a valid phone number without the country code",
          loading: false,
          phoneMessage: "Please enter a valid phone number",
          phoneMessageType: "error"
        });
        return;
      }

      // Update global user object
      global.user = {
        ...global.user,
        phone: this.state.countryCode + cleanPhone,
        countryCode: this.state.countryCode,
      };

      // Save to Firebase
      await FirebaseUsers.updateUserInfo();

      this.setState({ 
        loading: false,
        phoneMessage: "Phone number updated successfully!",
        phoneMessageType: "success"
      });

    } catch (error) {
      console.log('Error updating phone:', error);
      
      this.setState({ 
        loading: false,
        phoneMessage: "Error updating phone number. Please try again.",
        phoneMessageType: "error"
      });
    }
  }

  render() {
    return (
      <ScrollView style={mstyles.sContainer} contentContainerStyle={mstyles.sContent}>
        <EonnTitle>My Account</EonnTitle>

        {/* Phone Number Section */}
        <Text style={styles.sectionTitle}>Phone Number</Text>
        
        <PhoneField
          phoneValue={this.state.phone}
          countryCode={this.state.countryCode}
          onPhoneChange={value => this.setState({ 
            phone: value, 
            phoneMessage: "", 
            phoneMessageType: "" 
          })}
          onCountryCodeChange={value => this.setState({ 
            countryCode: value,
            phoneMessage: "", 
            phoneMessageType: "" 
          })}
          showRequired={this.state.showRequired}
        >
          Phone Number
        </PhoneField>

        <EonnButton
          loading={this.state.loading}
          onPress={this.updatePhone}
        >
          Save Profile
        </EonnButton>

        {/* Phone Update Message */}
        {this.state.phoneMessage ? (
          <Text style={this.state.phoneMessageType === 'success' ? styles.successMessage : styles.errorMessage}>
            {this.state.phoneMessage}
          </Text>
        ) : null}

        {/* Password Change Section */}        
        <EonnLink onPress={() => this.setState({ showPasswordSection: !this.state.showPasswordSection })}>
          {this.state.showPasswordSection ? "Hide Password Section" : "Change Password"}
        </EonnLink>

        {this.state.showPasswordSection && (
          <View style={{marginTop:10, alignItems:"center", justifyContent:"center"}}>
            {this.state.err ? (
              <Text style={mstyles.err}>{this.state.err}</Text>
            ) : null}
            
            <EonnField
              onChange={value => this.setState({ 
                password1: value, 
                pwError: false, 
                passwordMessage: "", 
                passwordMessageType: "" 
              })}
              showRequired={this.state.showRequired}
              showError={this.state.pwError}
              value={this.state.password1}
              textContentType={"password"}
              secureTextEntry={true}
            >
              Current Password
            </EonnField>
            
            <EonnField
              onChange={value => this.setState({ 
                password2: value, 
                pwError: false, 
                passwordMessage: "", 
                passwordMessageType: "" 
              })}
              showRequired={this.state.showRequired}
              showError={this.state.pwError}
              value={this.state.password2}
              textContentType={"password"}
              secureTextEntry={true}
            >
              New Password
            </EonnField>
            
            <EonnField
              onChange={value => this.setState({ 
                password3: value, 
                pwError: false, 
                passwordMessage: "", 
                passwordMessageType: "" 
              })}
              showRequired={this.state.showRequired}
              showError={this.state.pwError}
              value={this.state.password3}
              textContentType={"password"}
              secureTextEntry={true}
            >
              Confirm New Password
            </EonnField>
            
            <EonnButton
              loading={this.state.loading}
              navigationProps={this.props.navigation}
              showRequired={() => this.setState({ showRequired: true })}
              required={() => [
                this.state.password1,
                this.state.password2,
                this.state.password3
              ]}
              onPress={() => {
                this.setState({ 
                  loading: true, 
                  passwordMessage: "", 
                  passwordMessageType: "" 
                });
                
                if (this.state.password2 === this.state.password3) {
                  FirebaseUsers.changePassword(this.state.password1, this.state.password2)
                    .then(() => {
                      // Password changed successfully
                      console.log("Password changed successfully");
                      this.setState({ 
                        loading: false,
                        password1: "",
                        password2: "",
                        password3: "",
                        passwordMessage: "Password changed successfully!",
                        passwordMessageType: "success",
                        err: ""
                      });
                    })
                    .catch((error) => {
                      // Handle error changing password
                      let errorText = "";
                      switch (error.code) {
                        case 'auth/wrong-password':
                          errorText = "Incorrect current password";
                          break;
                        case 'auth/weak-password':
                          errorText = "New password is too weak";
                          break;
                        default:
                          errorText = "Error changing password";
                      }
                      this.setState({
                        err: errorText,
                        pwError: true,
                        emailError: false,
                        loading: false,
                        passwordMessage: errorText,
                        passwordMessageType: "error"
                      });
                      console.log(error);
                    });
                } else {
                  this.setState({
                    err: "New passwords don't match",
                    pwError: true,
                    emailError: false,
                    loading: false,
                    passwordMessage: "New passwords don't match",
                    passwordMessageType: "error"
                  });
                }
              }}
            >
              Update Password
            </EonnButton>

            {/* Password Change Message */}
            {this.state.passwordMessage ? (
              <Text style={this.state.passwordMessageType === 'success' ? styles.successMessage : styles.errorMessage}>
                {this.state.passwordMessage}
              </Text>
            ) : null}
          </View>
        )}
          
      </ScrollView>
    );
  }
}